import { Circle, Columns, HardDrive } from "react-feather";


const TaskManagement = [{
    id:"task-mgt",
    title:"Manajemen Task",
    icon:<Columns size={20}/>,
    navLink:"/task-management"
    },


]

export default TaskManagement